<div class="job-list-cont" [style.height]="maxHeight + 'px'">
  <ng-container *ngIf="!selectedJob && page.subsection !== ConceptSubSection.COMPARISON_TOOL; else selectedJobCont">
    <ng-container *ngFor="let job of jobsList; trackBy: trackByJobId">
      <div
        class="job-list-item"
        (click)="selectJob(job)"
        *ngIf="job.jobId"
        [ngClass]="{
          failed: isFailed(job),
          complete: isComplete(job),
          disabled: compareCheckboxesVisible && !['COMPLETED'].includes((job.finalStatus || job.lastStatus) ?? '')
        }"
        >
        <div class="job-list-item-meta" [ngClass]="{ 'checkbox-visible': compareCheckboxesVisible }"  [cyData]="'job-list-item-title'">
          <div class="job-list-item-title">
            <ng-container *ngIf="job.jobName && job.jobId; else generatingJob">
              {{ job.jobName }}
            </ng-container>
            <ng-template #generatingJob>
              <div class="generating">
                <awc-icon [icon]="Icons.SPINNER" [size]="iconXSmall"></awc-icon>
                <span>Generating Job Information...</span>
              </div>
            </ng-template>
          </div>

          <div class="job-list-item-status" [ngClass]="{ failed: isFailed(job), complete: isComplete(job) }">
            <span class="job-list-item-status-date">
              <ng-container *ngIf="job.lastStatus === 'RUNNING' && etaDisplay[job.jobId]; else displayDate">{{ etaDisplay[job.jobId] }}</ng-container>
              <ng-template #displayDate>
                <ng-container *ngIf="job.queuedStatusDate; else checkLastStatusDate">
                  {{ job.queuedStatusDate | date: 'mediumDate' }}
                </ng-container>
                <ng-template #checkLastStatusDate>
                  <ng-container *ngIf="job.lastStatusDate; else useNow">
                    {{ job.lastStatusDate | date: 'mediumDate' }}
                  </ng-container>
                </ng-template>
                <ng-template #useNow>
                  {{ currentDate | date: 'mediumDate' }}
                </ng-template>
              </ng-template>
            </span>
            <span *ngIf="isComplete(job) && jobDurations[job.jobId]" class="job-list-item-time-taken">
              {{ jobDurations[job.jobId] }}
            </span>
            <span class="job-list-item-status-state" [ngClass]="{ failed: isFailed(job), complete: isComplete(job) }">
              {{ job.cancelling ? 'CANCELLING…' : barlabels[job.jobId] | uppercase }}
            </span>
          </div>

          <div class="delete-wrapper">
            <div class="delete-cont" *ngIf="compareCheckboxesVisible">
              <div>
                <awc-icon
                  [icon]="selectedItems.includes(job?.jobId + '') ? Icons.CHECKBOX_CHECKED : Icons.CHECKBOX_UNCHECKED"
                  [color]="['COMPLETED'].includes((job.finalStatus || job.lastStatus) ?? '') ? ColorForeground.NEUTRAL_DEFAULT : ColorForeground.NEUTRAL_SUBTLER"
                  [class]="{'disabled': !['COMPLETED'].includes((job.finalStatus || job.lastStatus) ?? '')}"
                ></awc-icon>
              </div>
            </div>

            <div class="delete-cont" *ngIf="!compareCheckboxesVisible">
              <div
                *ngIf="getDeleteIcon(job) as icon"
                class="result-list-action-icons"
                (click)="onDeleteJob($event, job)"
              >
                <awc-icon [icon]="icon" [size]="iconSmall"></awc-icon>
              </div>

              <div
                *ngIf="['FAILED', 'FINISHED', 'PAUSED', 'CANCELLED', 'COMPLETED', 'COMPLETE', 'complete'].includes((trustedStatus[job.jobId]) ?? '')"
                class="result-list-action-icons"
                (click)="onRenameJob($event, job)"
                awcTooltipElement="Rename Job"
              >
                <awc-icon [icon]="Icons.EDIT" [size]="iconSmall"></awc-icon>
              </div>
            </div>
          </div>

          <div class="progress-bar">
            <ng-container [ngSwitch]="true">
              <ng-container [ngSwitch]="getProgressState(job)">
                <awc-progress-bar
                  *ngSwitchCase="'loading'"
                  [color]="ColorBackground.WARNING_DEFAULT"
                  [loading]="true">
                </awc-progress-bar>

                <awc-progress-bar
                  *ngSwitchDefault
                  [loading]="false"
                  [progressBarItem]="progressBars[job?.jobId || '']">
                </awc-progress-bar>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #selectedJobCont>
    <app-result-item
      [results]="results"
      [$resultsLoaded]="$resultsLoaded"
      [selectedResult]="selectedResult"
      (jobDeselected)="deselectJob($event)"
      (resultSelected)="selectResult($event)"
    ></app-result-item>
  </ng-template>
</div>
